<p-scroll-panel class="h-full">
  @let kunde = kundeService.selectedKunde();
  @if (kunde) {
    <div class="detail-section-header">Person data</div>
    <table class="detail-table">
      <tr>
        <td class="detail-label">Kunde id</td>
        <td>{{ kunde.id }}</td>
      </tr>
      <tr>
        <td class="detail-label">Cpr nummer</td>
        <td>{{ kunde.cprNummer | cprNummer }}</td>
      </tr>
      <tr>
        <td class="detail-label">Fornavn</td>
        <td>{{ kunde.fornavn }}</td>
      </tr>
      <tr>
        <td class="detail-label">Mellemnavne</td>
        <td>{{ kunde.mellemnavne }}</td>
      </tr>
      <tr>
        <td class="detail-label">Efternavn</td>
        <td>{{ kunde.efternavn }}</td>
      </tr>
      <tr>
        <td class="detail-label">Min situation oprettet</td>
        <td>{{ kunde.mineVaerdierId | boolean: 'Nej' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Har netbank</td>
        <td>{{ kunde.netbank | boolean: 'Nej' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Pensionsinfo modtaget</td>
        <td>{{ kunde.pensionsinfoOplysningerModtaget | boolean: 'Nej' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Arbejdsgiver</td>
        <td>Nej</td>
      </tr>
      <tr>
        <td class="detail-label">Rådgiver</td>
        <td>
          <a
            [routerLink]="['/raadgivere']"
            [queryParams]="{ id: kunde.raadgiverId }"
            >{{ kunde.raadgiver?.navn }}</a
          >
        </td>
      </tr>
    </table>

    <div class="detail-section-header">Kontakt info</div>
    <table class="detail-table">
      <tr>
        <td class="detail-label">Adresse</td>
        <td>{{ kunde.adresse?.vejnavn }} {{ kunde.adresse?.vejnr }}</td>
      </tr>
      <tr>
        <td class="detail-label">Postnr og by</td>
        <td>{{ kunde.adresse?.postnr }} {{ kunde.adresse?.bynavn }}</td>
      </tr>
      <tr>
        <td class="detail-label">Email</td>
        <td>{{ kunde.email }}</td>
      </tr>
    </table>

    <div class="detail-section-header">Helbred</div>
    <app-person-helbred [kunde]="kunde" />

    <div class="detail-section-header">Helbred historik</div>
    <app-person-helbred-historik
      [personId]="kunde.personOplysningerId"
      [refreshDate]="kundeService.refreshDate()"
      (dateSelected)="onDateSelected($event)" />
  }
</p-scroll-panel>
